<template>
  <div v-if="items.length">
    <p v-if="title" class="text-strong-body text-grey-header" :class="$slots.subtitle ? '' : 'mb-16'">{{ title }}</p>
    <div v-if="$slots.subtitle" class="mb-16">
      <slot name="subtitle" />
    </div>
    <div class="flex flex-wrap gap-16">
      <tag-label v-for="(item, index) in resolvedItems" :key="index" :item="item" />
    </div>
  </div>
</template>

<script lang="ts">
import TagLabel from '../tag_label/TagLabel.vue';
import { markItemsComponentsRaw } from '@/helpers/markComponentRaw';

interface TagItem {
  text: string;
  icon?: any;
}

export default {
  name: 'TagLabelGroup',
  components: {
    TagLabel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array as () => TagItem[],
      required: true,
    },
  },
  computed: {
    resolvedItems() {
      return markItemsComponentsRaw(this.items, ['icon']);
    },
  },
};
</script>
